<template>
    <div>
        <!--UI 加载中对话框开始-->
        <div id="PageUI_LoadingDialog" class="modal">
            <div class="modal-dialog">
                <div class="modal-content" style="height: 30px;;">
                    <div class="alert alert-warning" role="alert" style="border-radius:0;"><img src="../../static/images/loading.gif" style="width: 30px; height: 30px;;" border="0" />&nbsp;&nbsp;<span id="loadingtext">数据加载中,请稍候...</span></div>
                </div>
            </div>
        </div>
        <!--UI 加载中对话框结束-->

        <!--UI 提示对话框开始-->
        <div id="UI_Dialog_Alert" class="modal">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        <div class="modal-title">对话框标题</div>
                    </div>
                    <div class="modal-body" style="word-break: break-all;">对话框内容</div>
                    <div class="modal-footer">

                    </div>
                </div>
            </div>
        </div>
        
    </div>
    
</template>

<script>
    export default {
        name: 'bottom',
        data() {
            return {
                year: new Date().getFullYear()
            }
        }
    }
</script>

<style lang="scss" scoped>
</style>
